import { InMemoryCache } from '@apollo/client';
import { GET_USER_STEP } from 'graphqls/profile';

export const initializeOnboardingStep = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_USER_STEP,
    data: {
      onboardingStep: '',
    },
  });
};

export default {
  resolvers: {
    Mutation: {
      setOnboardingStep: (_, { onboardingStep }: { onboardingStep: string }, { cache }): string => {
        cache.writeQuery({
          query: GET_USER_STEP,
          data: {
            __typename: 'onboardingStep',
            onboardingStep,
          },
        });

        return onboardingStep;
      },
    },
  },
};
